import { imageLoader } from "@cornerstonejs/core"

import { _loadImageIntoBuffer } from "../webLoader"

export default function initWebImageLoader() {
  imageLoader.registerImageLoader("web", _loadImageIntoBuffer)
}
